<template>
    <div class="test-results">
        <div class="test-result-category">
            <h2 class="title">Uitslag</h2>
            <p class="description">
                <design-2021-apprentice-radar-chart-component
                    class="my-4"
                    :options="chartOptions"
                    :series="series">
                </design-2021-apprentice-radar-chart-component>
            </p>
        </div>
    </div>
</template>

<script>
import { getAttributesForKeys, sortResults } from '../../../../helpers/testCenter';

const testKey = 'cl4l-life-skills-assessment-2024-08-27';

export default {
    props: {
        resultData: {
            type: Object,
        },
    },
    data() {
        return {
            series: [
                {
                    color: '#07A1FF',
                    data: sortResults(testKey, this.resultData),
                    name: '',
                },
            ],
            chartOptions: {
                chart: {
                    width: '100%',
                    type: 'radar',
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                plotOptions: {
                    radar: {
                        size: 140,
                        polygons: {
                            strokeColors: '#e9e9e9',
                            fill: {
                                colors: ['#f8f8f8', '#fff'],
                            },
                        },
                    },
                },
                xaxis: {
                    categories: getAttributesForKeys(testKey, 'label'),
                    labels: {
                        style: {
                            colors: Array(Object.keys(this.resultData).length).fill('#212529'),
                            fontSize: '14px',
                        },
                    },
                },
                yaxis: {
                    min: 0,
                    max: 100,
                    labels: {
                        style: {
                            colors: '#a8a8a8',
                        },
                    },
                },
                tooltip: {
                    enabled: false,
                },
            },
        };
    },
};
</script>

<style scoped lang="scss">
.description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.apexcharts-text {
    color: $text-muted-color;
}
</style>
